import { UserFeedThreadSortOrder, UserWallFeedThreadSortOrder } from '@ms/yammer-data/dist/normalization/types';
import {
  FeedType,
  UserFeedSortType,
  UserFeedType,
  defaultStorylineSortBy,
  defaultUserSortBy,
} from '@ms/yammer-data/dist/state/types';

const userFeedSortTypes: Record<string, UserFeedSortType> = {
  ['CREATED_AT']: UserFeedThreadSortOrder.CREATED_AT,
  ['UPDATED_AT']: UserFeedThreadSortOrder.UPDATED_AT,
};

const userWallFeedSortTypes: Record<string, UserFeedSortType> = {
  ['CREATED_AT']: UserWallFeedThreadSortOrder.CREATED_AT,
  ['UPDATED_AT']: UserWallFeedThreadSortOrder.UPDATED_AT,
};

const defaultFeedSortTypes: Record<UserFeedType, UserFeedSortType> = {
  [FeedType.User]: defaultUserSortBy,
  [FeedType.UserWall]: defaultStorylineSortBy,
};

type GetUserFeedSortTypeByKey = (sortKey: string, type: UserFeedType) => UserFeedSortType;
type GetUserFeedSortTypeByUser = (type: UserFeedType) => UserFeedSortType;

const getUserFeedSortType: GetUserFeedSortTypeByKey = (sortKey, type) =>
  userFeedSortTypes[sortKey] ? userFeedSortTypes[sortKey] : defaultFeedSortTypes[type];
const getUserWallFeedSortType: GetUserFeedSortTypeByKey = (sortKey, type) =>
  userWallFeedSortTypes[sortKey] ? userWallFeedSortTypes[sortKey] : defaultFeedSortTypes[type];

export const getDefaultFeedSortType: GetUserFeedSortTypeByUser = (type) => defaultFeedSortTypes[type];

const userFeedTypeToSortTypeFunctionMap: Record<UserFeedType, GetUserFeedSortTypeByKey> = {
  [FeedType.User]: getUserFeedSortType,
  [FeedType.UserWall]: getUserWallFeedSortType,
};

type GetUserFeedSortBy = (type: UserFeedType, sortKey?: string) => UserFeedSortType;
export const getUserFeedSortBy: GetUserFeedSortBy = (type, sortKey) =>
  sortKey ? userFeedTypeToSortTypeFunctionMap[type](sortKey, type) : getDefaultFeedSortType(type);
